const middleware = {}

middleware['i18n'] = require('../middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['restrictRoutes'] = require('../middleware/restrictRoutes.js')
middleware['restrictRoutes'] = middleware['restrictRoutes'].default || middleware['restrictRoutes']

export default middleware
